import { render, staticRenderFns } from "./MapSettings.vue?vue&type=template&id=f89198c2&scoped=true"
import script from "./MapSettings.vue?vue&type=script&lang=js"
export * from "./MapSettings.vue?vue&type=script&lang=js"
import style0 from "./MapSettings.vue?vue&type=style&index=0&id=f89198c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89198c2",
  null
  
)

export default component.exports